var React = require('react');

function IconArrowBullet (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.9973 14.2014L17.8156 9.43647C18.0615 9.19327 18.0615 8.80595 17.8156 8.57175L13.0065 3.81579C12.8607 3.67167 12.6786 3.59961 12.4873 3.59961H0.619355C0.282353 3.59961 0 3.87884 0 4.21212V13.9132C0 14.1834 0.218596 14.3996 0.491841 14.3996H12.5055C12.6877 14.3996 12.8698 14.3275 12.9973 14.2014Z"}));
}

IconArrowBullet.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IconArrowBullet;

IconArrowBullet.default = IconArrowBullet;
